<div class="welcome">
  <div class="welcome__avatar">
    <img src="assets/copilot/brightside_bug.png" alt="Navi" class="welcome__avatar-img" />
  </div>
  <h1 class="welcome__heading">
    Welcome to Brightside Content
  </h1>
  <p class="welcome__subtext">
    Ask about Brightside processes, SOPs, partner and product guides, employer benefits, financial health topics, and more.
  </p>

  @if (prompts().length) {
    <div class="welcome__prompts">
      @for (prompt of prompts(); track prompt.key) {
        <button type="button" class="welcome__prompt" (click)="onPromptClick(prompt.macro)">
          {{ prompt.cta }}
        </button>
      }
    </div>
  }
</div>
